// Dados que a Cloudflare injeta no HTML da página principal (window.__EKKO_DATA__).
// Com eles, a página abre logo na versão final; sem eles, os componentes pedem à API.
export const initialData =
  typeof window !== "undefined" && window.__EKKO_DATA__ ? window.__EKKO_DATA__ : null;
